<template>
  <nav class="navbar navbar-expand-lg navbar-dark custom-navbar">
    <a class="navbar-brand" href="#">
      <img src="@/assets/images/light-logo.png" width="120">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"/>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto">
        <li class="nav-item active">
          <router-link class="nav-link" to="/">NNNCo NOC</router-link>
        </li>
        <li class="nav-item" :class="{active: route.name === 'base-stations'}">
          <router-link class="nav-link" to="/base-stations">Base Stations</router-link>
        </li>
        <li class="nav-item" :class="{active: route.name === 'alerts'}">
          <router-link class="nav-link" to="/alerts">Active Alerts</router-link>
        </li>
        <li class="nav-item" :class="{active: route.name === 'reports'}">
          <router-link class="nav-link" to="/reports">Reports</router-link>
        </li>
        <li class="nav-item" :class="{active: route.name === 'admin'}">
          <router-link class="nav-link" to="/admin">N2N Admin</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use "@/variables.scss" as *;

.custom-navbar {
  background-color: #343a40 !important;
}

.navbar-brand {
  margin-left: 1rem;
}

.nav-item.active .nav-link {
  color: white !important;
}
</style>
